import { useMemo } from 'react'
import type { BridgeConfig, BridgeMode } from '../config.js'

export function useQueryParams(): BridgeConfig {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    const mode = (params.get('mode') || 'translator') as BridgeMode
    return {
      workspace: params.get('workspace') || 'romea',
      assistantId: params.get('assistantId') || '',
      meetingId: params.get('meetingId') || '',
      mode,
    }
  }, [])
}
